var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"open-api-box"},[_c('iframe',{attrs:{"src":"/static/api.html","frameborder":"0","width":"100%","height":_vm.height,"scrolling":"no"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }